import "./PICOCard.css";
import { useContext } from "react";
import { PicoContext } from "../../Context/PicoContext";
import { TextField, Typography, Box, Stack } from "@mui/material";
export const PICOCard = () => {
  const { pico, setPico } = useContext(PicoContext);
  const { P, I, C, O, IC, EC } = pico;

  return (
    <Box className="PicoDetails">
      <Typography variant="h6" component="h3" className="PicoDetails__Title">
        Pico Details
      </Typography>
      <Stack direction="column" spacing={2} className="PicoDetails__Inputs">
        <TextField
          label="Population"
          variant="outlined"
          value={P}
          onChange={(e) => setPico((prev) => ({ ...prev, P: e.target.value }))}
          required
          multiline
          className="PicoDetails__Input"
        />
        <TextField
          label="Intervention"
          variant="outlined"
          value={I}
          onChange={(e) => setPico((prev) => ({ ...prev, I: e.target.value }))}
          required
          multiline
          className="PicoDetails__Input"
        />
        <TextField
          label="Comparision"
          variant="outlined"
          value={C}
          onChange={(e) => setPico((prev) => ({ ...prev, C: e.target.value }))}
          required
          multiline
          className="PicoDetails__Input"
        />
        <TextField
          label="Outcome"
          variant="outlined"
          value={O}
          onChange={(e) => setPico((prev) => ({ ...prev, O: e.target.value }))}
          required
          multiline
          className="PicoDetails__Input"
        />
        <TextField
          label="Inclusion Criteria"
          variant="outlined"
          value={IC}
          onChange={(e) => setPico((prev) => ({ ...prev, IC: e.target.value }))}
          required
          multiline
          className="PicoDetails__Input"
        />
        <TextField
          label="Exclusion Criteria"
          variant="outlined"
          value={EC}
          onChange={(e) => setPico((prev) => ({ ...prev, EC: e.target.value }))}
          required
          multiline
          className="PicoDetails__Input"
        />
      </Stack>
    </Box>
  );
};
